export default __webpack_public_path__ + "static/media/2.313c0a3c.mp3";